@let staticBackgroundColor = container?.staticBackgroundColor ? container?.staticBackgroundColor : 'rgb(255, 255, 255)';
@let background = container?.background ? 'linear-gradient(' + container?.background + ' 0%, ' + staticBackgroundColor + ' 60%)' : 'transparent';

<div [ngClass]="{ 'shadow': container?.boxShadow }"
     [ngStyle]="{ 'background': background }"
     class="main"
>
  <div [ngClass]="{ 'sp-header': container?.boxShadow || container?.background }" class="headSection">

    <div class="flex-container ion-justify-content-between ion-align-items-center gap-10 headerBox">
      @if (container?.title) {
        <div class="leftHeading col-bdy">
          <h4 class="sliderHeading" [ngStyle]="{ 'color': container?.sliderHeadingColor }">
            {{ container?.title | titlecase }}
          </h4>
        </div>
      }
      @if (showHeader) {
        <div class="middleBody col-bdy">
          <ng-content select="[header]"></ng-content>
        </div>
      }
      @if ((container?.seeAllFlag) || (!config?.showAbsoluteButtons && !config?.hideScrollButtons)) {
        <div class="rightBody btnSec col-bdy">
          <div class="gap-10"
               [ngClass]="{'flag-flex-box':container?.seeAllFlag}">
            @if (container?.seeAllFlag) {
              <!--<div (click)="onSeeAll()" class="viewBtn text-size-md ion-margin-end">
                View All
              </div>-->
              @if (container?.navigationURL) {
                <a [href]="container?.navigationURL" class="viewBtn"
                   [ngStyle]="{ 'color': container?.sliderHeadingColor }">
                  View all
                  <span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                       stroke="currentColor" class="size-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
                  </svg>
                </span>
                </a>
              }
            }
            @if (!config?.showAbsoluteButtons && !config?.hideScrollButtons) {
              <div class="flex-container ion-align-items-center ion-justify-content-end arrowSection">
                <a class="prev" (click)="goBack()">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                       stroke="currentColor" class="arrow">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"/>
                  </svg>
                </a>
                <a class="next" (click)="goForward()">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                       stroke="currentColor" class="arrow">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
                  </svg>
                </a>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (container?.description) {
      <p class="sliderSubHeading" [innerHTML]="container?.description | safe: 'html'"></p>
    }
  </div>
  <div [ngClass]="{ 'sp-body': container?.boxShadow || container?.background }" class="scroll-container">
    @if (!config?.hideScrollButtons && config?.showAbsoluteButtons) {
      <div class="nav-arrows">
        <a class="nav-prev flex-container ion-align-items-center ion-justify-content-center" (click)="goBack()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="arrow">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/>
          </svg>
        </a>
        <a class="nav-next flex-container ion-align-items-center ion-justify-content-center" (click)="goForward()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="arrow">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/>
          </svg>
        </a>
      </div>
    }
    <div #scrollContainer [ngStyle]="{'padding-bottom': container?.paddingBottom + 'px'}"
         [style.gap]="config?.spaceBetween + 'px'"
         class="scroll-bar"
         [ngClass]="{ 'hide-items': hidden, 'show-items': !hidden }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
